import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=14742a74&scoped=true"
import script from "./Crear.vue?vue&type=script&lang=js"
export * from "./Crear.vue?vue&type=script&lang=js"
import style0 from "./Crear.vue?vue&type=style&index=0&id=14742a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14742a74",
  null
  
)

export default component.exports